// extracted by mini-css-extract-plugin
export var divider = "_e1-7";
export var itemsToggle = "_e1-8";
export var mergeModal = "_e1-1";
export var optionCard = "_e1-4";
export var radioGroup = "_e1-6";
export var radioOption = "_e1-0";
export var selected = "_e1-5";
export var shipmentOptions = "_e1-2";
export var tableOptions = "_e1-3";